import { Col, Row } from 'react-bootstrap';
import AuditList from '../components/admin/audit/AuditList';
import AdminLayout from './layout/AdminLayout';
const AuditTrail = () => {
  
    return (
        <AdminLayout>
            <Row>
                <Col className="container mb-4">
                    <AuditList />
                </Col>
            </Row>
        </AdminLayout>
    )
}

export default AuditTrail;